import styles from './LpIntroduction.module.scss'

declare const hbspt: any
const LpIntroduction: React.FC = () => {
  return (
    <section className={styles.section} id="top">
      <img src="/images/LP/frontend/top.png" alt="TOP画面" className={styles.img} />
      <div className={styles.text_wrapper}>
        <h1>Single Page Application / ReactJS フロントエンド開発サービス</h1>
        <div className={styles.img_wrapper}>
          <img src="/images/LP/frontend/React.svg" alt="Reactロゴ" className={styles.react_logo} />
          <img src="/images/LP/frontend/Typescript.svg" alt="TypeScriptロゴ" className={styles.typescript_logo} />
          <img src="/images/LP/frontend/NextJS.png" alt="NextJSロゴ" className={styles.nextjs_logo} />
        </div>
        <p className={styles.text}>
          React JSやType
          Script、Next.jsなど、フロントエンドの開発に特化した、ウェブアプリケーションのコーディングサービスです。
        </p>
      </div>
    </section>
  )
}

export default LpIntroduction
